import _difference from 'lodash/difference';
import _differenceWith from 'lodash/differenceWith';
import _orderBy from 'lodash/orderBy';
import _sortedUniqBy from 'lodash/sortedUniqBy';
import _filter from 'lodash/filter';

export default function updateProgress(fieldDataList, question = {}, error = {}, setProgress) {
    const fieldList = fieldDataList.map(value => value.id);
    const fieldListIgnoreDuplicate = _sortedUniqBy(
        _orderBy(fieldDataList, ['id'], ['desc']),
        'sectionId'
    ).map(value => value.id);

    const fieldIgnoreList = _difference(fieldList, fieldListIgnoreDuplicate);

    const filledFieldListTemp = _filter(fieldDataList, value => {
        if (question[value.id] && !error[value.id]) {
            return value;
        }
    }).map(value => value.id);

    const validFieldList = _differenceWith(filledFieldListTemp, fieldIgnoreList);

    const progress = Math.floor((validFieldList.length / fieldListIgnoreDuplicate.length) * 100);
    setProgress(progress);
}
